<script setup>
import dayjs from 'dayjs'
import { RichTextRenderer } from '@marvr/storyblok-rich-text-vue-renderer'

const props = defineProps({ blok: Object, date: String })
const { path, params } = useRoute()

function formattedText(text) {
  return text.replace(/-/g, ' ')
}
function normalizePath(path) {
  return path.replace(/\/+/g, '/')
}
const filteredArray = params.slug.filter(item => item !== '')

useHead({
  title: `${props.blok?.title ? props.blok?.title : props.blok?.title}`,
  meta: [
    {
      name: 'description',
      content: props.blok?.description,
    },
    {
      name: 'keywords',
      content: '',
    },
    {
      property: 'og:title',
      content: props.blok?.title,
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:locale',
      content: 'en_US',
    },
    {
      property: 'og:description',
      content: props.blok?.description,
    },
    {
      property: 'og:image',
      content: props.blok?.image?.filename,
    },
    {
      property: 'og:url',
      content: `https://www.dexon-technology.com/news/${props.blok?.full_slug}`,
    },
    {
      name: 'twitter:card',
      content: props.blok?.image?.filename,
    },
    {
      name: 'twitter:title',
      content: props.blok?.title,
    },
    {
      name: 'twitter:description',
      content: props.blok?.description,
    },
    {
      name: 'twitter:image',
      content: props.blok?.image?.filename,
    },
  ],
})
</script>

<template>
  <div
    v-editable="blok"
    class="pt-mobile-navbar lg:pt-desktop-navbar"
  >
    <div class="pb-mobile pt-custom-sm container lg:pb-desktop">
      <div class="mx-auto max-w-4xl">
        <div class="mb-custom-sm flex gap-2 overflow-x-auto pl-0 pt-custom-lg md:gap-4 !px-0">
          <div v-for="(item, index) in filteredArray" :key="item">
            <div class="flex items-center gap-3">
              <svg v-if="index !== 0" class="h-3.5 w-3.5 text-primary" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 5l6 7l-6 7" /></svg>
              <NuxtLink :to="localePath(filteredArray.length === index + 1 ? { path: normalizePath(`/${path}`) } : item === 'activities' ? { path: '/sustainability/activities' } : { path: normalizePath(`/${item}`) })">
                <span :class="filteredArray.length === index + 1 ? 'text-primary !cursor-default font-semibold' : 'text-primary/90 font-medium hover:text-green-500'" class="whitespace-nowrap text-sm capitalize">{{ formattedText(item) }}</span>
              </NuxtLink>
            </div>
          </div>
        </div>
        <nuxt-img width="896" height="505" loading="lazy" sizes="md:900px, sm:600px, xs:500px" :src="`${blok.image.filename}`" :alt="blok.title" class="mb-custom-lg w-full rounded-md" />
        <h1 class="mb-custom-sm text-2xl font-bold md:text-3xl !leading-9">
          {{ blok.title }}
        </h1>
        <div class="my-3">
          <ul class="pl-0">
            <li class="mb-0">
              <div class="flex items-center gap-x-2.5">
                <nuxt-img width="50" height="50" src="https://a.storyblok.com/f/236289/128x128/68f485c8bf/master_dexon_rgb_cs6_2-05.jpg" alt="avatar" class="h-10 w-10 rounded-full" />
                <b class="text-md text-primary font-semibold">Dexon Technology</b>
              </div>
            </li>
          </ul>
        </div>
        <div class="mb-custom-xl text-sm text-gray-500 font-medium">
          <span v-if="!props.date">{{ dayjs(props.date).format('DD MMMM YYYY') }}</span>
          <span v-else>{{ dayjs(blok.date).format('DD MMMM YYYY') }}</span>
        </div>
        <div v-if="blok" class="article auto-width">
          <RichTextRenderer :document="blok.content" />
        </div>
      </div>
    </div>
  </div>
</template>
